import * as ActionTypes from './types';

export function getCategoriesWithFilters(payload) {
  return {
    type: ActionTypes.GET_CATEGORIES_WITH_FILTERS,
    payload: payload
  }
}

export function getCategoriesWithFiltersSuccess(payload) {
  return {
    type: ActionTypes.GET_CATEGORIES_WITH_FILTERS_SUCCESS,
    payload: payload
  }
}

export function getCategoriesWithFiltersFailed(payload) {
  return {
    type: ActionTypes.GET_CATEGORIES_WITH_FILTERS_FAILED,
    payload: payload
  }
}

export function changeCategoriesState(payload) {
  return {
    type: ActionTypes.CHANGE_CATEGORIES_STATE,
    payload: payload
  }
}

export function getCategories(payload) {
  return {
    type: ActionTypes.GET_CATEGORIES,
    payload: payload
  }
}

export function getCategoriesSuccess(payload) {
  return {
    type: ActionTypes.GET_CATEGORIES_SUCCESS,
    payload: payload
  }
}

export function getCategoriesFailed(payload) {
  return {
    type: ActionTypes.GET_CATEGORIES_FAILED,
    payload: payload
  }
}



// WEBPACK FOOTER //
// ./src/actions/categories.js